import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedComponentsModule } from './components/shared-components.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ErrorStateMatcher as MaterialErrorStateMatcher, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ErrorStateMatcher } from './material/error-state-matcher';
import { FileUploadModule } from 'ng2-file-upload';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG, CurrencyMaskModule } from "ng2-currency-mask";
import {
  DateFormatAdapter,
  PICK_FORMATS
} from './material/date-format-adapter';
import { PaginatorPtbr } from './material/paginator';
import { BcrowValidatorModule } from './bcrow-validator/bcrow-validator.module';
import { VehiclesPagesModule } from './components/vehicles-pages/vehicles-pages.module';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.'
};

const imports = [
  CommonModule,
  PerfectScrollbarModule,
  ToastrModule.forRoot({
    preventDuplicates: true
  }),
  NgbModule,
  SharedComponentsModule,
  SharedDirectivesModule,
  SharedPipesModule,
  RouterModule,
  NgxMaskDirective,
  NgxMaskPipe,
];

const exports = [
  NgbModule,
  MatInputModule,
  SharedDirectivesModule,
  SharedComponentsModule,
  ReactiveFormsModule,
  FormsModule,
  MatPaginatorModule,
  MatIconModule,
  MatDatepickerModule,
  MatCheckboxModule,
  MatSelectModule,
  MatTabsModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  FileUploadModule,
  MatTooltipModule,
  CurrencyMaskModule,
  MatRadioModule,
  BcrowValidatorModule,
  VehiclesPagesModule,
  NgxMaskDirective,
  NgxMaskPipe,
];

const providers = [
  { provide: MaterialErrorStateMatcher, useValue: new ErrorStateMatcher() },
  { provide: DateAdapter, useClass: DateFormatAdapter },
  { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
  { provide: MatPaginatorIntl, useClass: PaginatorPtbr },
  { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
];



@NgModule({
  imports,
  exports,
  providers
})
export class SharedModule { }
